@import 'abstract/colors';
@import 'abstract/variables';

$sm-mobile-width: 360px;
$mobile-width: 576px;
$mobile-height: 812px;

@mixin sm-mobile {
  @media (max-width: $sm-mobile-width) { @content; }
}

@mixin mobile {
  @media (max-width: $mobile-width) { @content; }
}

@mixin landscape {
  @media (max-width: $mobile-height) and (orientation: landscape) { @content; }
}

@mixin sm-mobile-and-landscape() {
  @include sm-mobile { @content; }
  @include landscape { @content; }
}

@mixin mobile-and-landscape() {
  @include mobile { @content; }
  @include landscape { @content; }
}

select-region-modal.active {
  position: fixed;
  z-index: 5000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  @include mobile {
    z-index: 2147483646;
  }
}

select-region-modal {
.background {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba($dark-blue, 0.7);

  @include mobile-and-landscape {
    background: white;
  }
}

.close-button {
  font-size: 0;
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  width: 20px;
  height: 20px;
  padding: 0;
  cursor: pointer;
  border: none;
  background: none;

  &:before, &:after {
    position: absolute;
    left: -4px;
    width: 28px;
    height: 2px;
    content: "";
    transform: rotateZ(45deg);
    border-radius: 3px;
    background: $blue-grey;
  }

  &:after {
    transform: rotateZ(-45deg);
  }

  @include mobile {
    top: 10px;
    right: 10px;
  }

  @include landscape {
    top: 20px;
    right: 15px;
  }
}

section {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  max-width: 560px;
  padding: 20px;
  cursor: auto;
  border-radius: 10px;
  background: white;
  box-shadow: 0 11px 15px -7px rgb(0 0 0 / 20%),
  0 24px 38px 3px rgb(0 0 0 / 14%),
  0 9px 46px 8px rgb(0 0 0 / 12%);

  @include mobile-and-landscape {
    width: 100%;
    max-width: 560px;
    height: 100%;
    margin-top: 0;
    border-radius: 0;
    box-shadow: none;
  }

  @include mobile {
    padding: 5px;
  }
}

h3 {
  font-size: 18px;
  font-weight: 500;
  margin-top: 0;
  text-align: center;

  @include mobile {
    font-size: 20px;
    margin-top: 10px;
    margin-bottom: 25px;
  }

  @include sm-mobile-and-landscape {
    font-size: 18px;
  }
}

.content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0;
  padding: 0;

  @include mobile {
    justify-content: space-around;
  }
}

.link {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  width: calc(33% - 8px);
  height: 180px;
  margin-bottom: 15px;
  padding: 15px;
  text-decoration: none;
  border: 1px solid $sky-blue;
  border-radius: 5px;

  &:hover {
    cursor: pointer;
    box-shadow: 0 3px 7px $box-shadow;
  }

  @include mobile-and-landscape {
    justify-content: flex-start;
    width: calc(50% - 16px);
    min-width: 0;
    max-width: 150px;
    height: auto;
    margin: 8px;
    text-align: center;
  }

  @include sm-mobile-and-landscape {
    padding: 10px;
  }
}

img {
  width: 65px;
  height: 65px;
  margin-bottom: 20px;

  @include mobile {
    margin-bottom: 15px;
  }

  @include sm-mobile-and-landscape {
    width: 40px;
    height: 40px;
    margin-bottom: 8px;
  }
}

span {
  font-size: 15px;
  font-weight: 500;
  line-height: 28px;
  margin: 0;
  color: $main-blue;

  @include mobile {
    font-size: 16px;
    line-height: 1.5;
  }
}

}
